import script from "./nameplate-reissue-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./nameplate-reissue-list.vue?vue&type=script&lang=ts&setup=true"

import "./nameplate-reissue-list.vue?vue&type=style&index=0&id=0df3b5c2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df3b5c2"]])

export default __exports__